import { camelCase, snakeCase } from "lodash/fp";
import { mapKeysDeep } from "utils";
import * as API from "lib/api/types";

export const deserializePayload = (payload: API.SerializedPayload): API.Payload =>
  mapKeysDeep(camelCase)(payload as Record<any, any>);

export const serializePayload = (payload: API.Payload): API.SerializedPayload =>
  mapKeysDeep(snakeCase)(payload as Record<any, any>);
